import React, { Component } from 'react';
import  './index.css';
import {
  changeInTime4KeyPress,
  scaledChangeInDist4KeyPress,
  imageBasePath,
  minimal,
} from '../../library/constants';
import {
  isMobileTablet,
} from '../../library/calc';

class Pan extends Component {

  render () {

    const { canvasHeight, isPedigree, zoomAnimateCenterPedigree, gotoFocusNode, cleanUp, hideProductTour } = this.props;


    const topPanBoxStyle = {
      top: `${ canvasHeight + this.props.canvasTop - 150 + ( this.props.canvasTop * -1 )}px`,
      left: '58px',
      backgroundImage: `url(${imageBasePath}up.svg)`,
    };
    const rightPanBoxStyle = {
      top: `${ canvasHeight + this.props.canvasTop - 110 + ( this.props.canvasTop * -1 )}px`,
      left: '100px',
      backgroundImage: `url(${imageBasePath}right.svg)`,
    };
    const bottomPanBoxStyle = {
      top: `${ canvasHeight + this.props.canvasTop - 70 + ( this.props.canvasTop * -1 )}px`,
      left: '58px',
      backgroundImage: `url(${imageBasePath}down.svg)`,
    };
    const leftPanBoxStyle = {
      top: `${ canvasHeight + this.props.canvasTop - 110 + ( this.props.canvasTop * -1 )}px`,
      left: '16px',
      backgroundImage: `url(${imageBasePath}left.svg)`,
    };

    const dim = ( isMobileTablet() ? 31: 34);
    let top = ( isMobileTablet() ? 65: 115);
    const left = ( isMobileTablet() ? 43: 53);

    // const styleObj = buildImgStyleObjBasedOnOrientation({nodeObj: focusNodeObj});

    const shiftUp = (minimal ? -5: 0);
    const shiftLeft = (minimal ? +20: 0);
    let bullseyeStyle = {
      // ...styleObj,
      position: 'absolute',
      top: `${ canvasHeight + this.props.canvasTop - top + ( this.props.canvasTop * -1 ) - shiftUp}px`,
      left: `${left - shiftLeft}px`,
      float: 'left',
      cursor: 'pointer',
      width: `${dim}px`,
      height: `${dim}px`,
      // backgroundImage: `url(${focusNodeObj.img.src})`,
      background: `url(${imageBasePath}bullseye.svg) no-repeat `,
      backgroundSize: `${dim}px ${dim}px`,
      opacity: .5
    }

    if( this.props.stageBackgroundCustomColor === '#000000'){
      bullseyeStyle = {...bullseyeStyle, ...{
        background: `url(${imageBasePath}bullseye_blk_bg.svg) no-repeat `,
        opacity: .7,
      }};
    }

    return (
      <div id="panBoxWrapper" className="desktopBoxControls">

        {

        isMobileTablet() || minimal

        ?
          null

        :

          <div>
            <div style={topPanBoxStyle} className="panBox" onClick={()=>this.props.velocityMove('vertical', 1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)}>
            </div>
            <div  style={rightPanBoxStyle}  className="panBox" onClick={()=>this.props.velocityMove('horizontal', -1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)}>
            </div>
            <div  style={bottomPanBoxStyle}  className="panBox" onClick={()=>this.props.velocityMove('vertical', -1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)}>
            </div>
            <div  style={leftPanBoxStyle}  className="panBox"  onClick={()=>this.props.velocityMove('horizontal', 1, scaledChangeInDist4KeyPress, changeInTime4KeyPress)}>
            </div>
          </div>


        }


        {

        isMobileTablet() && this.props.isDualPedigree

        ?

          null

        :

        <div id="bullseye" style={{
          ...bullseyeStyle,
          background: `${ ( isMobileTablet() ? 'transparent': 'white')}`,
        }} >

           <div
              style={{
                ...bullseyeStyle,
                top: '0px',
                left: '0px',
              }}
              onClick={()=>{
                if( typeof(window.forceHideMoreList) !== 'undefined' ) window.forceHideMoreList();
                hideProductTour({ fromWhere: '95485703', withLastStepNotify: true});
                cleanUp({closePedigreeAddbox: true});
                if(isPedigree){
                  zoomAnimateCenterPedigree();
                } else if(this.props.isFanChart){
                  this.props.gotoFanChartCenter();
                } else{
                  gotoFocusNode({fromWhere:'8'});
                }
              }}
            >
          </div>
        </div>

        }
      </div>
    );
  }
}

export default Pan;

